import { apiMockSwitcher } from 'APIPackage/MainModule/mock/apiMockSwitcher';

import { APIServiceEnum } from '../../MainModule/enums/APIServiceEnum';
import { handleResponse } from '../../MainModule/common/handleResponse';
import { getServiceBaseURL } from '../../MainModule/common/getServiceBaseURL';
import { IPmCanceledReason } from '../interfaces/IPmCanceledReason';

export async function fetchPmCanceledReasons(): Promise<IPmCanceledReason[]> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/pm-canceled-reasons`;
  const mockData = apiMockSwitcher<IPmCanceledReason[]>(url, 'GET');

  if (mockData) return mockData;

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}
